import React from 'react'

import {
  setIsFaqModalOpen,
  setIsMobileMenuOpen,
  setIsSaveProjectToMailModalOpen,
  setIsSaveProjectOfferModalOpen,
  setIsSummaryPreviewExpanded,
  setIsUserGuideModalOpen,
} from '../../store/ui/uiSlice'

import { FULFILLED } from '../../constants/constants'
import { useAppDispatch, useAppSelector } from '../../hooks'

const Menu: React.FC = () => {
  const dispatch = useAppDispatch()

  const { content } = useAppSelector((state) => state.init)
  const { requestStatus_fetchPrices_aggregated } = useAppSelector((state) => state.requests.requestStatus)

  const { isMobileMenuOpen, isSummaryPreviewExpanded, shouldRenderFaq, shouldRenderUserGuide, isSummaryPanelVisible } =
    useAppSelector((state) => state.ui)

  return (
    <>
      {!isSummaryPanelVisible && (
        <>
          <button
            className="button-mobile-menu"
            onClick={() => {
              if (isSummaryPreviewExpanded) dispatch(setIsSummaryPreviewExpanded(false))
              dispatch(setIsMobileMenuOpen(!isMobileMenuOpen))
            }}
            data-testid="expand-button-for-small-screens"
          >
            <i className="fas fa-bars" aria-hidden="true" />
          </button>

          <ul className="menu">
            <li className="menu-item" data-testid="menu-item-save-project-to-mail">
              <button
                disabled={requestStatus_fetchPrices_aggregated !== FULFILLED}
                onClick={() => {
                  if (requestStatus_fetchPrices_aggregated === FULFILLED) {
                    if (isSummaryPreviewExpanded) dispatch(setIsMobileMenuOpen(false))
                    dispatch(setIsSaveProjectToMailModalOpen(true))
                  }
                }}
              >
                <i className="far fa-inbox-in" aria-hidden="true" />
                {content?.modals?.saveProjectToMail?.menu}
              </button>
            </li>
            <li className="menu-item">
              <button
                disabled={requestStatus_fetchPrices_aggregated !== FULFILLED}
                onClick={() => {
                  if (requestStatus_fetchPrices_aggregated === FULFILLED) {
                    if (isSummaryPreviewExpanded) dispatch(setIsMobileMenuOpen(false))
                    dispatch(setIsSaveProjectOfferModalOpen(true))
                  }
                }}
                data-testid="menu-item-save-project-offer"
              >
                <i className="far fa-file-pdf" aria-hidden="true" />
                {content?.modals?.saveProjectOffer?.menu}
              </button>
            </li>
            {shouldRenderFaq && (
              <li className="menu-item">
                <button
                  onClick={() => {
                    if (isSummaryPreviewExpanded) dispatch(setIsMobileMenuOpen(false))
                    dispatch(setIsFaqModalOpen(true))
                  }}
                >
                  <i className="far fa-list-alt" aria-hidden="true" />
                  {content?.modals?.faq?.menu}
                </button>
              </li>
            )}
            {shouldRenderUserGuide && (
              <li className="menu-item">
                <button
                  onClick={() => {
                    if (isSummaryPreviewExpanded) dispatch(setIsMobileMenuOpen(false))
                    dispatch(setIsUserGuideModalOpen(true))
                  }}
                >
                  <i className="far fa-question-square" aria-hidden="true" />
                  {content?.modals?.userGuide?.menu}
                </button>
              </li>
            )}
          </ul>
        </>
      )}
    </>
  )
}

export default Menu
